import { API_BASE_URL } from "../config";
import type { OrderStatus } from "./types";

export const ORDER_STATUS: Record<OrderStatus, { label: string; icon: string; hint: string }> = {
  pending: { label: "等接单", icon: "💌", hint: "点菜单已经送达" },
  accepted: { label: "接单啦", icon: "💗", hint: "正在准备制作" },
  cooking: { label: "在做啦", icon: "🍳", hint: "厨房正在冒香气" },
  ready: { label: "开饭啦", icon: "🍽️", hint: "可以准备吃饭啦" },
  completed: { label: "吃光光", icon: "✨", hint: "这顿饭完成啦" },
  declined: { label: "这次做不了", icon: "🌙", hint: "换一道或者改天再吃" },
};

export function formatDate(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat("zh-CN", {
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(date);
}

export function resolveMediaUrl(url: string | null | undefined): string {
  if (!url) return "";
  try {
    const media = new URL(url);
    const api = new URL(API_BASE_URL);
    if (["localhost", "127.0.0.1"].includes(media.hostname) && media.hostname !== api.hostname) {
      media.protocol = api.protocol;
      media.hostname = api.hostname;
      media.port = api.port;
    }
    return media.toString();
  } catch {
    return url;
  }
}

export function createIdempotencyKey(): string {
  return globalThis.crypto?.randomUUID?.() || `order-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}
